import React, {useRef, useState} from "react";
import {GatsbyImage} from "gatsby-plugin-image";
import {useScrollMonitor} from "scrollmonitor-hooks";
import ArrowLink from "../global/arrow-link";
import {Link} from "gatsby";

const Banner = (
  {
    imageData = null,
    imageDataHover = null,
    contentPosition = 'default',
    projectData = null,
    children
  }
) => {
  const parentRef = useRef(null);
  const [bannerViewClass, setBannerViewClass] = useState('');
  const [isHover, setHoverState] = useState(false);

  const parentMouseEnterHandler = () => {
    setHoverState(true);
  }

  const parentMouseLeaveHandler = (event) => {
    if ( parentRef?.current.contains(event.relatedTarget) ) {
      return;
    }

    setHoverState(false);
  }

  const cardViewCallbacks = {
    enterViewport: () => {
      setBannerViewClass('banner--in-view');
    }
  }

  useScrollMonitor(parentRef, cardViewCallbacks);

  return (
    <section
      className={`banner ${bannerViewClass}`}
      onMouseOver={parentMouseEnterHandler}
      onMouseOut={parentMouseLeaveHandler}
      ref={parentRef}
    >
      <Link
        className="details-footer__link-container"
        to={projectData.link.url}
      >
        <div className="banner__media-wrapper">
          <div className={`banner__image-container banner__image-container--image-1 ${isHover ? 'mouseEnter' : 'mouseLeave'}`}>
            <GatsbyImage
              className="banner__image"
              image={imageData}
              alt="Evo"
            />
          </div>
          <div className={`banner__image-container banner__image-container--image-2 ${isHover ? 'mouseEnter' : 'mouseLeave'}`}>
            <GatsbyImage
              className="banner__image banner__image--hover-image"
              image={imageDataHover}
              alt="Evo"
            />
          </div>
        </div>
        {projectData?.link.title && (
          <div className={`banner__content-wrapper banner__content-wrapper--${contentPosition}`}>
            <h2 className={`banner__title banner__title--${contentPosition}`}>{children}</h2>
            {projectData?.link.title && (
              <ArrowLink
                className="banner__arrow-link"
                text={projectData.link.title}
                isLink={false}
                isAnimation={isHover}
                transitionDuration={600}
              />
            )}
          </div>
        )}
      </Link>
    </section>
  )
}

export default Banner
